module.exports = __webpack_public_path__ + "img/ex10.fbc83519.jpg";